import { inject, Injectable } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';
import { AutomationConditionErrorsType } from '@recruitee/workflow-automations-types';

@Injectable({ providedIn: 'root' })
export class AutomationConditionErrorsService {
  private readonly i18n = inject(I18nService);

  public readonly errorsMap: Record<AutomationConditionErrorsType, string> = {
    [AutomationConditionErrorsType.EmptyPreferredLocation]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_preferred_location',
    ),
    [AutomationConditionErrorsType.EmptyLocation]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_location',
    ),
    [AutomationConditionErrorsType.EmptyDepartment]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_department',
    ),
    [AutomationConditionErrorsType.EmptyCondition]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_condition',
    ),
    [AutomationConditionErrorsType.EmptyOrganizer]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_organizer',
    ),
    [AutomationConditionErrorsType.EmptyRecruiter]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_recruiter',
    ),
    [AutomationConditionErrorsType.EmptyHiringManager]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_hiring_manager',
    ),
    [AutomationConditionErrorsType.EmptyTags]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_tags',
    ),
    [AutomationConditionErrorsType.EmptyInterviewers]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_interviewers',
    ),
    [AutomationConditionErrorsType.EmptyAssignees]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_assignees',
    ),
    [AutomationConditionErrorsType.EmptyWorkModel]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_work_model',
    ),
    [AutomationConditionErrorsType.EmptyCreator]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_creator',
    ),
    [AutomationConditionErrorsType.EmptyPreviousStatus]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_previous_status',
    ),
    [AutomationConditionErrorsType.EmptySourceTags]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_source_tags',
    ),
    [AutomationConditionErrorsType.EmptyOrigin]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_origin',
    ),
    [AutomationConditionErrorsType.EmptyFromStage]: this.i18n.translate(
      'app.workflow_automations.automations_wizard_dialog.conditions.errors.empty_from_stage',
    ),
  };

  public getFirstErrorLabel(
    possibleFieldErrors: AutomationConditionErrorsType[],
    errors: Record<AutomationConditionErrorsType, boolean | null>,
  ): string | null {
    const firstErrorKey = Object.keys(errors).find(
      (key: AutomationConditionErrorsType) => possibleFieldErrors.includes(key) && errors[key],
    );
    return firstErrorKey
      ? this.errorsMap[<AutomationConditionErrorsType>firstErrorKey] || null
      : null;
  }
}
